<div class="dialog-header">
  <img id="stateMessageModalCloseImage" class="close-img" src="assets/images/button_close.svg" (click)="onNoClick()" />
</div>
<div mat-dialog-title id="stateMessageModalHeader" class="dialog-header">
  <p id="stateMessageHeaderText">Important Information</p>
</div>
<mat-dialog-content id="stateMessageContent" class="mat-typography">
   <p [innerHTML]="message"></p>
</mat-dialog-content>